
(function(){
  function $(sel, root){ return (root||document).querySelector(sel); }
  function $$(sel, root){ return Array.prototype.slice.call((root||document).querySelectorAll(sel)); }
  function money(n){ n=parseFloat(n||0); return n.toFixed(2); }
  var roots = $$('.lume-product-page-final');
  if(!roots.length) return;
  roots.forEach(function(root){
  if (root.dataset.lumePdpReady === 'true') return;
  root.dataset.lumePdpReady = 'true';

  // Gallery
  (function(){
    var main=$('#gMainImg', root);
    var thumbs=$$('.g-thumb', root);
    var rail=$('.g-thumbs', root);
    var idx=0;
    var cache={};
    function preload(src){ if(!src || cache[src]) return; var img=new Image(); img.decoding='async'; img.src=src; cache[src]=img; }
    function preloadAround(index){
      if(!thumbs.length)return;
      var previous=(index-1+thumbs.length)%thumbs.length;
      var next=(index+1)%thumbs.length;
      preload(thumbs[previous]&&thumbs[previous].getAttribute('data-src'));
      preload(thumbs[next]&&thumbs[next].getAttribute('data-src'));
    }
    preloadAround(0);
    thumbs.forEach(function(t){
      function preloadIntent(){preload(t.getAttribute('data-src'));}
      t.addEventListener('mouseenter',preloadIntent,{once:true,passive:true});
      t.addEventListener('focus',preloadIntent,{once:true,passive:true});
      t.addEventListener('touchstart',preloadIntent,{once:true,passive:true});
    });
    function ensureThumbVisible(thumb){
      if(!rail || !thumb) return;
      var railRect=rail.getBoundingClientRect();
      var thumbRect=thumb.getBoundingClientRect();
      if(thumbRect.left < railRect.left){
        rail.scrollBy({left:thumbRect.left-railRect.left-8,behavior:'smooth'});
      }else if(thumbRect.right > railRect.right){
        rail.scrollBy({left:thumbRect.right-railRect.right+8,behavior:'smooth'});
      }
    }
    var isSwitching=false;
    function show(i,direction){
      if(!thumbs.length||!main||!mainStage||isSwitching)return;
      var nextIndex=(i+thumbs.length)%thumbs.length;
      if(nextIndex===idx){ensureThumbVisible(thumbs[nextIndex]);return;}

      var src=thumbs[nextIndex].getAttribute('data-src');
      if(!src)return;

      var moveDirection=direction||(nextIndex>idx?1:-1);
      var loader=cache[src]||new Image();
      if(!cache[src]){loader.src=src;cache[src]=loader;}

      var ready=loader.decode?loader.decode().catch(function(){}):new Promise(function(resolve){
        if(loader.complete)resolve();
        else{loader.onload=resolve;loader.onerror=resolve;}
      });

      ready.then(function(){
        isSwitching=true;

        var incoming=document.createElement('img');
        incoming.className='g-transition-img';
        incoming.alt=main.alt||'';
        incoming.decoding='async';
        incoming.src=src;
        incoming.style.setProperty('--gallery-enter-x',moveDirection>0?'14px':'-14px');
        mainStage.appendChild(incoming);

        requestAnimationFrame(function(){
          requestAnimationFrame(function(){
            incoming.classList.add('is-visible');
          });
        });

        var finished=false;
        function finish(){
          if(finished)return;
          finished=true;
          idx=nextIndex;
          thumbs.forEach(function(x,n){x.classList.toggle('active',n===idx);});
          main.removeAttribute('srcset');
          main.src=src;
          ensureThumbVisible(thumbs[idx]);
          preloadAround(idx);
          incoming.remove();
          isSwitching=false;
        }

        incoming.addEventListener('transitionend',finish,{once:true});
        window.setTimeout(finish,360);
      });
    }
    thumbs.forEach(function(t,i){t.addEventListener('click',function(){show(i,i>idx?1:-1)});});
    var prev=$('.g-prev', root), next=$('.g-next', root);
    if(prev)prev.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();show(idx-1,-1);});
    if(next)next.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();show(idx+1,1);});

    // Smooth live swipe: the main product image follows the finger.
    var mainStage=$('.g-main', root);
    if(mainStage&&main){
      var swipeStartX=0;
      var swipeStartY=0;
      var swipeDx=0;
      var swipeWidth=0;
      var swipeAxis='';
      var swipeActive=false;
      var swipeDirection=0;
      var swipeTargetIndex=idx;
      var swipePreview=null;
      var swipeFrame=0;
      var swipeStartedAt=0;

      function setSwipeX(element,x){
        if(!element)return;
        element.style.transform='translate3d('+x+'px,0,0)';
      }

      function removeSwipePreview(){
        if(swipePreview&&swipePreview.parentNode){
          swipePreview.parentNode.removeChild(swipePreview);
        }
        swipePreview=null;
      }

      function createSwipePreview(direction){
        if(!direction||!thumbs.length)return false;
        if(swipePreview&&swipeDirection===direction)return true;

        removeSwipePreview();
        swipeDirection=direction;
        swipeTargetIndex=(idx+direction+thumbs.length)%thumbs.length;

        var targetThumb=thumbs[swipeTargetIndex];
        var targetSource=targetThumb&&targetThumb.getAttribute('data-src');
        if(!targetSource)return false;

        swipePreview=document.createElement('img');
        swipePreview.className='g-swipe-preview';
        swipePreview.alt=main.alt||'';
        swipePreview.draggable=false;
        swipePreview.decoding='async';
        swipePreview.setAttribute('aria-hidden','true');
        swipePreview.src=targetSource;
        setSwipeX(swipePreview,direction*swipeWidth);
        mainStage.appendChild(swipePreview);
        return true;
      }

      function drawSwipe(){
        swipeFrame=0;
        if(!swipePreview)return;
        setSwipeX(main,swipeDx);
        setSwipeX(swipePreview,(swipeDirection*swipeWidth)+swipeDx);
      }

      function requestSwipeDraw(){
        if(swipeFrame)return;
        swipeFrame=requestAnimationFrame(drawSwipe);
      }

      function resetMainPosition(){
        /*
         * Reset without animating back across the gallery. The CSS class uses
         * !important so it reliably overrides the normal swipe transition.
         */
        mainStage.classList.add('is-swipe-resetting');
        setSwipeX(main,0);
        requestAnimationFrame(function(){
          requestAnimationFrame(function(){
            mainStage.classList.remove('is-swipe-resetting');
          });
        });
      }

      function finishSwipe(commit){
        if(!swipePreview){
          mainStage.classList.remove('is-swipe-dragging');
          resetMainPosition();
          isSwitching=false;
          return;
        }

        var preview=swipePreview;
        var direction=swipeDirection;
        var targetIndex=swipeTargetIndex;
        var targetSource=preview.getAttribute('src');
        var completed=false;
        swipePreview=null;

        mainStage.classList.remove('is-swipe-dragging');

        requestAnimationFrame(function(){
          setSwipeX(main,commit?-direction*swipeWidth:0);
          setSwipeX(preview,commit?0:direction*swipeWidth);
        });

        function completeTransition(){
          if(completed)return;
          completed=true;

          if(!commit){
            resetMainPosition();
            if(preview.parentNode)preview.parentNode.removeChild(preview);
            isSwitching=false;
            return;
          }

          idx=targetIndex;
          thumbs.forEach(function(thumb,index){
            thumb.classList.toggle('active',index===idx);
          });
          ensureThumbVisible(thumbs[idx]);
          preloadAround(idx);

          var cleaned=false;
          var cleanupTimer=null;

          function cleanupPreview(){
            if(cleaned)return;
            cleaned=true;
            if(cleanupTimer)window.clearTimeout(cleanupTimer);

            // Keep the preview covering the gallery while the main image is
            // reset underneath it. The reset must happen with no transition,
            // otherwise the old image visibly slides back after the swipe.
            mainStage.classList.add('is-swipe-resetting');
            setSwipeX(main,0);

            requestAnimationFrame(function(){
              requestAnimationFrame(function(){
                if(preview.parentNode)preview.parentNode.removeChild(preview);
                mainStage.classList.remove('is-swipe-resetting');
                isSwitching=false;
              });
            });
          }

          main.addEventListener('load',cleanupPreview,{once:true});
          main.addEventListener('error',cleanupPreview,{once:true});
          main.removeAttribute('srcset');
          main.src=targetSource;

          if(main.complete&&main.naturalWidth>0)cleanupPreview();
          cleanupTimer=window.setTimeout(cleanupPreview,800);
        }

        preview.addEventListener('transitionend',function(event){
          if(event.propertyName==='transform')completeTransition();
        },{once:true});
        window.setTimeout(completeTransition,440);
      }

      mainStage.addEventListener('touchstart',function(event){
        if(isSwitching||!event.touches||event.touches.length!==1){
          swipeActive=false;
          return;
        }

        swipeWidth=mainStage.getBoundingClientRect().width||1;
        swipeStartX=event.touches[0].clientX;
        swipeStartY=event.touches[0].clientY;
        swipeDx=0;
        swipeAxis='';
        swipeDirection=0;
        swipeActive=true;
        swipeStartedAt=Date.now();
      },{passive:true});

      mainStage.addEventListener('touchmove',function(event){
        if(!swipeActive||!event.touches||event.touches.length!==1)return;

        var currentX=event.touches[0].clientX;
        var currentY=event.touches[0].clientY;
        var dx=currentX-swipeStartX;
        var dy=currentY-swipeStartY;

        if(!swipeAxis&&Math.max(Math.abs(dx),Math.abs(dy))>5){
          swipeAxis=Math.abs(dx)>Math.abs(dy)?'horizontal':'vertical';
        }
        if(swipeAxis!=='horizontal')return;

        if(event.cancelable)event.preventDefault();

        var direction=dx<0?1:-1;
        if(!createSwipePreview(direction))return;

        isSwitching=true;
        swipeDx=Math.max(-swipeWidth,Math.min(swipeWidth,dx));
        mainStage.classList.add('is-swipe-dragging');
        requestSwipeDraw();
      },{passive:false});

      mainStage.addEventListener('touchend',function(){
        if(!swipeActive)return;
        swipeActive=false;

        if(swipeAxis!=='horizontal'||!swipePreview){
          swipeAxis='';
          removeSwipePreview();
          mainStage.classList.remove('is-swipe-dragging');
          resetMainPosition();
          isSwitching=false;
          return;
        }

        var elapsed=Math.max(1,Date.now()-swipeStartedAt);
        var velocity=Math.abs(swipeDx)/elapsed;
        var threshold=Math.min(90,Math.max(42,swipeWidth*.14));
        var commit=Math.abs(swipeDx)>=threshold||(velocity>.42&&Math.abs(swipeDx)>18);

        swipeAxis='';
        finishSwipe(commit);
      },{passive:true});

      mainStage.addEventListener('touchcancel',function(){
        if(!swipeActive)return;
        swipeActive=false;
        swipeAxis='';
        if(swipePreview)finishSwipe(false);
        else{
          mainStage.classList.remove('is-swipe-dragging');
          resetMainPosition();
          isSwitching=false;
        }
      },{passive:true});
    }
  })();

  // Quantity breaks + dynamic ATC price
  (function(){
    var opts=$$('.qty-opt', root), up=$('#upsellCheck', root),
        atc=$('#atcBtn', root), sticky=$('#stickyBtn', root),
        eur=$('#priceEur', root), bgn=$('#priceBgn', root),
        old=$('#priceOld', root), save=$('#priceSave', root),
        rate=parseFloat(root.getAttribute('data-rate')||'1.95583'),
        upPrice=parseFloat(root.getAttribute('data-upsell-price')||'0');
    function selected(){ return $('.qty-opt.selected', root) || opts[1] || opts[0]; }
    function selectOption(option){
      if(!option) return;
      opts.forEach(function(x){
        var active=x===option;
        x.classList.toggle('selected',active);
        x.setAttribute('aria-pressed',active?'true':'false');
      });
      update();
    }
    function update(){
      var sel=selected(); if(!sel) return;
      var e=parseFloat(sel.getAttribute('data-eur')||'0');
      var selectedBgn=parseFloat(sel.getAttribute('data-bgn')||'0');
      var total=e+((up&&up.checked)?upPrice:0);
      if(eur) eur.textContent='€'+money(e);
      if(bgn) bgn.textContent=money(selectedBgn || e*rate).replace('.',',')+' лв';
      if(old){
        var oldValue=sel.getAttribute('data-old')||'';
        old.textContent=oldValue?'€'+oldValue:'';
        old.hidden=!oldValue;
      }
      if(save) save.textContent=sel.getAttribute('data-save')||'';
      if(atc && !atc.disabled) atc.textContent=(atc.getAttribute('data-label')||'Добави в количката');
      if(sticky) sticky.textContent=(sticky.getAttribute('data-label')||'Добави');
    }
    opts.forEach(function(o){
      o.addEventListener('click',function(){selectOption(o)});
      o.addEventListener('keydown',function(event){
        if(event.key==='Enter'||event.key===' '){event.preventDefault();selectOption(o);}
      });
    });
    if(up)up.addEventListener('change',update);
    var defaultOption=$('.qty-opt.selected', root) || opts[1] || opts[0];
    if(defaultOption) selectOption(defaultOption);
    else update();
  })();

  // Delivery estimate
  (function(){
    var note=$('[data-lume-delivery]', root);
    var target=note && note.querySelector('[data-lume-delivery-date]');
    if(!note||!target)return;
    var minDays=Math.max(0,parseInt(note.getAttribute('data-min-days')||'1',10));
    var maxDays=Math.max(minDays,parseInt(note.getAttribute('data-max-days')||'3',10));
    var weekdays=['неделя','понеделник','вторник','сряда','четвъртък','петък','събота'];
    function addBusinessDays(date,days){
      var result=new Date(date.getFullYear(),date.getMonth(),date.getDate());
      var added=0;
      while(added<days){
        result.setDate(result.getDate()+1);
        var day=result.getDay();
        if(day!==0&&day!==6)added++;
      }
      return result;
    }
    var start=addBusinessDays(new Date(),minDays);
    var end=addBusinessDays(new Date(),maxDays);
    var label=weekdays[start.getDay()];
    if(start.toDateString()!==end.toDateString())label+=' и '+weekdays[end.getDay()];
    target.textContent=' '+label;
  })();

  // Add to cart
  (function(){
    var buttons=$$('.js-lume-atc', root);
    function addToCart(btn){
      if(!btn || btn.disabled) return;
      var sel=$('.qty-opt.selected', root);
      var variantId=btn.getAttribute('data-main-variant-id');
      var qty=parseInt((sel&&sel.getAttribute('data-quantity'))||'1',10);
      var items=[];
      if(variantId) items.push({id:Number(variantId), quantity:qty});
      var up=$('#upsellCheck', root);
      if(up && up.checked && up.getAttribute('data-variant-id')) items.push({id:Number(up.getAttribute('data-variant-id')), quantity:1});
      if(!items.length) return;
      var original=btn.textContent;
      buttons.forEach(function(b){b.disabled=true});
      btn.textContent=btn.getAttribute('data-loading')||'Добавяне...';
      var request;
      if (window.LumeCart && typeof window.LumeCart.addItems === 'function') {
        request = window.LumeCart.addItems(items, true);
      } else {
        request = fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
          .then(function(r){ if(!r.ok) return r.json().then(function(e){ throw e; }); return r.json(); })
          .then(function(){ return fetch('/cart.js').then(function(r){return r.json()}); });
      }
      request.then(function(cart){
          $$('.cart-count', root).forEach(function(c){ c.textContent=cart.item_count || 0; });
          buttons.forEach(function(b){ b.textContent=b.getAttribute('data-added')||'Добавено ✓'; });
          setTimeout(function(){ buttons.forEach(function(b){ b.disabled=false; }); var evt=new Event('change'); var up=$('#upsellCheck', root); if(up) up.dispatchEvent(evt); },1200);
        })
        .catch(function(err){
          buttons.forEach(function(b){b.disabled=false});
          var msg=(err&&err.description)||'Неуспешно добавяне. Моля, опитай отново.';
          btn.textContent=msg;
          setTimeout(function(){ btn.textContent=original; },2200);
        });
    }
    buttons.forEach(function(btn){ btn.addEventListener('click', function(e){ e.preventDefault(); addToCart(btn); }); });
    $$('.up-add', root).forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); var up=$('#upsellCheck', root); if(up) up.checked=true; var atc=$('#atcBtn', root); if(atc) addToCart(atc); }); });
  })();

  // Sticky ATC
  (function(){
    var bar=$('#stickyAtc', root), trigger=$('#atcBtn', root); if(!bar||!trigger)return;
    window.addEventListener('scroll',function(){ var r=trigger.getBoundingClientRect(); bar.classList.toggle('show',r.bottom<0); },{passive:true});
  })();

  // Ticker
  (function(){var t=$('#tickerTrack', root); if(t && !t.dataset.ready){t.innerHTML+=t.innerHTML;t.dataset.ready='1';}})();

  // BA slider: mobile-safe touch handling without pointer-capture freezes.
  (function(){
    var s=$('#baSlider', root),a=$('#baAfter', root),h=$('#baHandle', root); if(!s||!a||!h)return;
    var frame=0,pendingX=null,mouseDown=false,startX=0,startY=0,axis='';
    function draw(){frame=0;if(pendingX===null)return;var r=s.getBoundingClientRect(),p=Math.max(0,Math.min(1,(pendingX-r.left)/r.width));a.style.clipPath='inset(0 0 0 '+(p*100)+'%)';h.style.left=(p*100)+'%';s.setAttribute('aria-valuenow',Math.round(p*100));pendingX=null;}
    function set(x){pendingX=x;if(!frame)frame=requestAnimationFrame(draw);}
    s.addEventListener('touchstart',function(e){if(!e.touches||e.touches.length!==1)return;startX=e.touches[0].clientX;startY=e.touches[0].clientY;axis='';},{passive:true});
    s.addEventListener('touchmove',function(e){if(!e.touches||e.touches.length!==1)return;var x=e.touches[0].clientX,y=e.touches[0].clientY,dx=x-startX,dy=y-startY;if(!axis&&Math.max(Math.abs(dx),Math.abs(dy))>6)axis=Math.abs(dx)>Math.abs(dy)?'x':'y';if(axis==='x'){if(e.cancelable)e.preventDefault();set(x);}},{passive:false});
    s.addEventListener('touchend',function(){axis='';},{passive:true});
    s.addEventListener('touchcancel',function(){axis='';},{passive:true});
    s.addEventListener('mousedown',function(e){if(e.button!==0)return;mouseDown=true;set(e.clientX);e.preventDefault();});
    window.addEventListener('mousemove',function(e){if(mouseDown)set(e.clientX);});
    window.addEventListener('mouseup',function(){mouseDown=false;});
    s.addEventListener('keydown',function(e){var now=parseInt(s.getAttribute('aria-valuenow'))||50;if(e.key==='ArrowLeft')now-=5;else if(e.key==='ArrowRight')now+=5;else return;e.preventDefault();var r=s.getBoundingClientRect();set(r.left+r.width*Math.max(0,Math.min(100,now))/100);});
  })();

  // Zones
  (function(){
    $$('.z-item', root).forEach(function(it){
      it.addEventListener('click',function(){ var z=it.dataset.zone; $$('.z-item', root).forEach(function(x){x.classList.toggle('active',x===it)}); $$('.z-fig', root).forEach(function(f){f.classList.toggle('active',f.dataset.fig===z)}); $$('.z-detail', root).forEach(function(d){d.hidden=d.dataset.detail!==z}); });
    });
  })();

  // Accordions - one open item per group with measured, smooth height transitions.
  (function(){
    function closeItem(item){
      var q=item.querySelector('.acc-q'),a=item.querySelector('.acc-a');if(!a)return;
      a.style.maxHeight=a.scrollHeight+'px';
      requestAnimationFrame(function(){item.classList.remove('open');a.style.maxHeight='0px';if(q)q.setAttribute('aria-expanded','false');});
    }
    function openItem(item){
      var q=item.querySelector('.acc-q'),a=item.querySelector('.acc-a');if(!a)return;
      item.classList.add('open');a.style.maxHeight='0px';if(q)q.setAttribute('aria-expanded','true');
      requestAnimationFrame(function(){a.style.maxHeight=a.scrollHeight+'px';});
    }
    $$('.acc-item', root).forEach(function(item){
      var q=item.querySelector('.acc-q'),a=item.querySelector('.acc-a');if(!q||!a)return;
      q.setAttribute('aria-expanded',item.classList.contains('open')?'true':'false');
      if(item.classList.contains('open'))a.style.maxHeight=a.scrollHeight+'px';
      q.addEventListener('click',function(){
        var wasOpen=item.classList.contains('open');
        var group=item.closest('.acc')||item.parentElement;
        if(group)$$('.acc-item',group).forEach(function(other){if(other!==item&&other.classList.contains('open'))closeItem(other);});
        if(wasOpen)closeItem(item);else openItem(item);
      });
    });
  })();

  // UGC slider
  (function(){
    var tr=$('#ugcTrack', root); if(!tr)return;
    $$('.ugc-arrow', root).forEach(function(a){ a.addEventListener('click',function(){tr.scrollBy({left:(a.classList.contains('next')?1:-1)*250,behavior:'smooth'})}); });
    $$('.ugc-media', root).forEach(function(c){ var v=c.querySelector('video'); if(!v)return; v.addEventListener('error',function(){v.remove()},true); c.addEventListener('mouseenter',function(){v.play().catch(function(){})}); c.addEventListener('mouseleave',function(){v.pause()}); });
  })();

  // Stats count-up with final-value fallback on every device.
  (function(){
    var els=$$('.cnt', root).filter(function(el){
      if(el.dataset.lumeCounterReady==='true')return false;
      el.dataset.lumeCounterReady='true';
      var target=parseFloat(el.dataset.target),decimals=parseInt(el.dataset.decimals||'0',10),suffix=el.dataset.suffix||'';
      if(Number.isFinite(target))el.textContent=target.toFixed(decimals)+suffix;
      return true;
    });
    if(!els.length||!('IntersectionObserver' in window))return;
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(!en.isIntersecting)return;
        io.unobserve(en.target);
        var el=en.target,t=parseFloat(el.dataset.target),d=parseInt(el.dataset.decimals||'0',10),suf=el.dataset.suffix||'',start=null;
        if(!Number.isFinite(t))return;
        function step(ts){
          if(!start)start=ts;
          var p=Math.min(1,(ts-start)/900);p=1-Math.pow(1-p,3);
          el.textContent=(t*p).toFixed(d)+suf;
          if(p<1)requestAnimationFrame(step);else el.textContent=t.toFixed(d)+suf;
        }
        requestAnimationFrame(step);
      });
    },{threshold:.25});
    els.forEach(function(e){io.observe(e);});
  })();
  });
})();
